<template>
  <div class="mars-ape-layout-header">
    <div class="header-left">
      <i class="iconfont header-index-trigger" v-if="mxIsContract == 1"
         :class="[isCollapse?'icon-menu-fold':'icon-menu-unfold']" @click="handleClick"></i>
      <div class="header-index-trigger" style="padding-left:12px;padding-right:12px;" v-else></div>
    </div>
    <div class="header-middle">
      <el-row :gutter="20">
		<div class="content-label">商户与服务公司：</div>
		<el-cascader
		class="elcascader"
		filterable
		v-model="cas_companyData_value"
		:options="cas_companyData"
		:props="cas_props"
		@focus="event_casFocus"
		@blur="event_casBlur"
		@change="cas_handleChange"></el-cascader>
      </el-row>
    </div>
    <div class="header-right">
      <el-button type="text" class="info" @click="gotoAnnounce">
        <el-badge :value=" (this.localStroageId != this.id) ? 1 : null" class="item">
          <i class="el-icon-message-solid" style="font-size: 20px"
             :id="(this.localStroageId != this.id) ? 'has-message' : 'nohas-message'"></i>
        </el-badge>
      </el-button>
      <el-dropdown @command="handleCommand">
        <span class="right-account">
          <span class="right-account-avatar">
            <img src="@/assets/avatar.png" alt="avatar">
          </span>
          <span class="right-account-name">{{ userInfo['fullname'] }}</span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="setting" v-if="is_yichen"><i class="iconfont icon-touxiang"></i><span>个人设置</span></el-dropdown-item>
          <el-dropdown-item divided command="logout"><i class="iconfont icon-tuichudenglu2"></i><span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState, mapMutations} from 'vuex'
const channel_broad = new BroadcastChannel('my-channel')
export default {
  data() {
    return {
	cas_change:false,
	cas_change_before:[],
	cas_props:{
		label:'name',
		value:'id',
		children:'channel'
	},
	cas_companyData_value:[],
	cas_companyData:[],
		is_yichen:false,
      form: {
        companyId: '',
        settlementId: '',
      },
      localStroageId: '',
      id: '',
      isAlipay: false
    }
  },
  inject: ['reload'],
  computed: {
    ...mapState({
      companyList: state => state.switchInfo.companyList,
      settlementList: state => state.switchInfo.settlementList,
    }),
    ...mapGetters({
      isCollapse: 'isCollapse',
      userInfo: 'userInfo',
    }),
    companyId: {
      get() {
        return this.mxCompanyId
      },
      set(value) {
        this.$store.commit('changeSwitchInfo', {key: 'companyId', value: value})
      },
    },
    settlementId: {
      get() {
        return this.mxSettlementId
      },
      set(value) {
        this.$store.commit('changeSwitchInfo', {key: 'settlementId', value: value})
      },
    },
  },
  watch: {
    "companyId": function (v) {
      this.getCompanyList()
      let companyIds = this.$config.domain?.settlmentlCustom?.companyIds||[]
      let newSettlementList = Object.assign(this.settlementList, [])
      companyIds.forEach(item => {
        if (item == v) {
          newSettlementList.forEach(i => {
            if (this.$config.domain.settlmentlCustom.originName.includes(i.name)) {
              i.name = this.$config.domain.settlmentlCustom.currentName
            }
          })
          this.$store.commit('changeSwitchInfo', {key: 'settlementList', value: newSettlementList})
        }
      })
    }
  },
  methods: {
    ...mapMutations([
      'handleUserInfo'
    ]),
	event_casFocus(){
		this.cas_change_before = this.cas_companyData_value
		this.cas_companyData_value = []
		console.log(this.cas_change_before,'之前的值')
	},
	event_casBlur(){
		this.cas_companyData_value = this.cas_change_before
		console.log('失去焦点')
	},
	// 级联选择器切换
	cas_handleChange(e){
		this.cas_change = true
		this.companyId = e[0]
		this.settlementId = e[1]
		this.companyChange(this.companyId)
		this.settlementChange(this.settlementId)
		this.onSubmit()
		channel_broad.postMessage('reload')
	},
    async getInfo() {
      let data = await this.$api.getPrice()
      this.id = data.announcement.id
    },
    //查看公告消息
    async gotoAnnounce() {
      // if( this.id ) {
      //   this.$router.push('/notice')
      // }
      this.$router.push('/notice')
    },
    // 左侧菜单的展开折叠
    handleClick() {
      this.$store.commit('changeCollapse')
    },
    // 处理下拉菜单指令
    handleCommand(command) {
      if (command === 'setting') {
        this.$router.push('/information')
      }
      if (command === 'logout') {
        this.handleLogout()
      }
    },
    // 处理退出
    async handleLogout() {
      this.$api.submitLogout()
      localStorage.removeItem('user_info')
      // this.$storage.remove('accountment_id')
      this.$message.success('退出成功！')
      this.$router.push('/loginIndex')
    },
    // 公司选择
    async companyChange(v) {
      if (v) {
        const companyList = []
        for (let key in this.companyList) {
          companyList.push(this.companyList[key])
        }
        const nowCompany = companyList.find((item) => {
          return item.id === v
        })
        localStorage.setItem("nowCompany", JSON.stringify(nowCompany))
        this.$store.commit('changeSwitchInfo', {key: 'nowCompany', value: nowCompany})
        this.$store.commit('changeSwitchInfo', {key: 'companyId', value: v})
        let args = {company_id: v}
        const settlementList = await this.$api.getUserSettlement(args)
        let companyIds = this.$config.domain?.settlmentlCustom?.companyIds||[]
        let newSettlementList = Object.assign(settlementList, [])
        companyIds.forEach(item => {
          if (v == item) {
            newSettlementList.forEach((i) => {
              if (this.$config.domain.settlmentlCustom.originName.includes(i.name)) {
                i.name = this.$config.domain.settlmentlCustom.currentName
              }
            })
            this.$store.commit('changeSwitchInfo', {key: 'settlementList', value: newSettlementList})
          }
        })
        this.$store.commit('changeSwitchInfo', {key: 'settlementList', value: settlementList})
      }
    },
    // 服务公司选择
    async settlementChange(v) {
      console.log(v, '结果数据')
      const nowTaxSource = this.settlementList.filter((item) => {
        return item.id === v
      })
      this.$store.commit('changeSwitchInfo', {key: 'nowTaxSource', value: nowTaxSource})
      if (v) {
        this.$store.commit('changeSwitchInfo', {key: 'settlementId', value: v})
        localStorage.setItem("settlementId", v)
      }
    },
    // 按钮提交
    async onSubmit() {
      let info = await this.$api.userSwitch(this.companyId, this.settlementId)
      if (info) {
        this.mxInitUserInfo()
        if (this.$route.path === '/home') {
          this.reload()
        } else {
          this.mxRedirect('/home')
        }
        // localStorage.setItem("XL_COMPANY_ID", this.companyId)
        // localStorage.setItem("XL_SETTLEMENT_ID", this.settlementId)
        // this.$notify({
        //   title: 'SYSTEM',
        //   message: '公司切换成功',
        //   type: 'success',
        //   duration: 3000
        // })
        // this.reload()
        this.$message({
          message: '切换成功',
          type: 'success',
          duration: '500'
        })
      }
    },
	
	// new_get_company
	// 获取公司列表
	async getCompanyList(){
		this.cas_companyData = []
		this.cas_companyData = this.companyList
		this.cas_companyData_value = [this.companyId,this.settlementId]
		this.cas_companyData.map(item=>{
			if(item.channel.length != 0){
				item.channel.map(child=>{
					if(child.id == '15001103560099'){
						let tar = child.name
						if(!tar.includes('（新）')){
							child.name = `${tar}（新）`
						}
					}
				})
			}
		})
	}
  },
  mounted() {
	this.is_yichen = !this.$storage.get('is_yichen');
    // this.getInfo()
    // this.localStroageId = this.$storage.get("accountment_id")
	this.getCompanyList()
	
	let that = this
	channel_broad.onmessage = function(event) {
		if(event.data == 'reload'){
			that.$router.push('/home')
			window.location.reload()
		}
	};
  },
}
</script>

<style lang="stylus" scoped>
.elcascader
  width 420px
  position absolute
  top 13px

.content-label
  float left
  margin-right 3px
  margin-left 10px

.mars-ape-layout-header .iconfont
  display inline-block
  box-sizing border-box
  font-size 24px

.mars-ape-layout-header
  height 64px
  background #fff
  box-shadow 0 1px 4px rgba(0, 21, 41, .08)
  position relative
  overflow hidden

.mars-ape-layout-header > .header-left, .mars-ape-layout-header > .header-middle
  float left
  color #595959

.mars-ape-layout-header > .header-middle
  line-height 64px

.mars-ape-layout-header > .header-right
  float right
  line-height 64px
  overflow hidden

.mars-ape-layout-header > .header-left > .header-index-trigger
  font-size 20px
  height 64px
  cursor pointer
  transition all .3s, padding 0s
  padding 22px 24px

i.header-index-trigger:hover
  background rgba(0, 0, 0, .025)

.header-right .right-account, .header-right .right-notice
  padding 0 12px
  display inline-block
  transition all .3s
  cursor pointer
  color: rgba(0, 0, 0, .65)

.right-notice .el-badge
  line-height 24px

.right-account-avatar > img
  width 100%
  display block

.right-account-avatar
  width 24px
  line-height 24px
  border-radius 50%
  display inline-block
  margin 20px 8px 20px 0
  vertical-align top

.right-account-name
  font-size 14px

.right-notice:hover, .right-account:hover
  background rgba(0, 0, 0, .025)

.el-dropdown-menu__item
  padding 5px 12px
  line-height 22px
  font-weight 400
  color rgba(0, 0, 0, 0.65)

.el-dropdown-menu__item > .iconfont
  margin-right 8px

.el-dropdown-menu
  padding 4px 0
  margin 0px

.el-dropdown-menu__item--divided
  padding-top 0px
  line-height 28px

.el-dropdown-menu__item--divided::before
  margin 0 -12px

.el-dropdown-menu.el-popper
  min-width 160px
  top 56px !important

.el-popper .popper__arrow
  border-width 0px

.el-popper .popper__arrow::after
  border-width 0px

.el-select
  width 280px

.btn-swtich
  margin-left 15px

.info
  margin-right: 10px
  height: 100%

#has-message
  color: #f56c6c

#nohas-message
  color: #909399

#nohas-message:hover
  color #46A6FF
</style>